<iframe
    [src]="url"
    frameBorder="0"
    scrolling="no"
    width="100%"
    height="100%"></iframe>
